// 操作数类型枚举
export enum OperandType {
  DEFAULT = 0,
  VARIABLE = 1, // 变量 - 属性
  CONSTANT = 2, // 常量 -数值
}

// 操作数接口
export interface Operand {
  operandType: OperandType;
  variableNumId: string;
  constantVal: number;
}

// 运算符类型枚举
export enum OperatorsType {
  DEFAULT = 0,
  ADD = 1,    // +
  SUB = 2,    // -
  MULTI = 3,  // *
  DIVIDE = 4, // ÷
  EQ = 5,     // =
  GT = 6,     // >
  LT = 7,     // <
  LTE = 8,    // <=
  GTE = 9,    // >=
  AND = 10,   // 且
  OR = 11     // 或
}

export enum NumericalSystemType {
  NS_TYPE_GLOBAL_DEFAULT = 0,
  NS_TYPE_GLOBAL_NORMAL = 1,
  NS_TYPE_GLOBAL_PERMANENT = 2,
}
